import React, { useState, useEffect } from 'react';
import { ListItem, ListItemSecondaryAction, ListItemText, ListItemAvatar } from '@material-ui/core';
import { CloseRounded } from '@material-ui/icons';
import InputText from '../../../../../commonModules/interface/form-input-inline';
import LinkSpending from '../../../Repayment/LinkSpending';
import Currency from '../../../../../commonModules/Currency';

const LinkPurchasePopUp = (props) => {
    const [state, setState] = useState({
        parts: {},
        max: {},
        total: {},
        errors: {},
    });

    useEffect(() => {
        const { PURCHASES, checkedPayments, transfer } = props;
        const parts = {};
        const max = {};
        const total = {};
        console.log('====================================');
        console.log({checkedPayments, PURCHASES, transfer});
        console.log('====================================');
        checkedPayments.forEach((ID) => {
            // Si le transfer est passé et correspond à l'ID, utiliser le transfer directement
            if (transfer && transfer.id === ID) {
                // Pour un transfer, utiliser prix_revient comme montant disponible
                const available = transfer.purchase_total_available || transfer.prix_revient || transfer.total_price || 0;
                parts[ID] = available;
                max[ID] = available;
                total[ID] = transfer.prix_revient || transfer.total_price || 0;
            } else if (PURCHASES && PURCHASES[ID]) {
                parts[ID] = PURCHASES[ID].total_available || PURCHASES[ID].purchase_total_available || PURCHASES[ID].prix_revient || 0;
                max[ID] = PURCHASES[ID].total_available || PURCHASES[ID].purchase_total_available || PURCHASES[ID].prix_revient || 0;
                total[ID] = PURCHASES[ID].prix_revient || 0;
            }
        });

        setState((prevState) => ({
            ...prevState,
            parts,
            max,
            total,
        }));

        props.handleChangeParts(parts);
    }, [props.PURCHASES, props.checkedPayments, props.transfer]);

    const handleChange = (e, ID) => {
        const { name, value } = e.target;
        const { parts } = state;

        setState((prevState) => ({
            ...prevState,
            parts: {
                ...parts,
                [ID]: parseFloat(value),
            },
        }));

        props.handleChangeParts({
            ...parts,
            [ID]: parseFloat(value),
        });
    };

    const rmPayment = (ID) => {
        const { parts } = state;
        const updatedParts = { ...parts };
        delete updatedParts[ID];

        setState((prevState) => ({
            ...prevState,
            parts: updatedParts,
        }));

        props.rmPayment(ID);
    };

    return (
        <LinkSpending 
            title="Pointer les achats" 
            handleChange={props.handleChange}
            spendingID={props.spendingID}
            handleSubmitLink={props.handleSubmitLink}
            totalPay={props.totalPay}
            handleClose={props.handleClose}
        >
            {(props.checkedPayments && Array.isArray(props.checkedPayments) ? props.checkedPayments : []).map((ID) => {
                // Utiliser le transfer si disponible, sinon utiliser PURCHASES
                const purchase = (props.transfer && props.transfer.id === ID) 
                    ? props.transfer 
                    : (props.PURCHASES && props.PURCHASES[ID]) 
                        ? props.PURCHASES[ID] 
                        : null;
                
                if (!purchase) return null;
                
                const shopName = props.SHOPS && props.SHOPS[purchase.shop_id] 
                    ? props.SHOPS[purchase.shop_id].name 
                    : 'Magasin inconnu';
                const date = purchase.creation_date || purchase.date || new Date();
                
                return (
                    <ListItem key={ID}>
                        <ListItemAvatar onClick={() => rmPayment(ID)} style={{ cursor: 'pointer' }}>
                            <CloseRounded color="error" />
                        </ListItemAvatar>
                        <ListItemText
                            primary={shopName}
                            secondary={new Date(date).toLocaleString('fr-FR')}
                        />
                        <ListItemSecondaryAction>
                            <InputText
                                required
                                label="Montant"
                                type="number"
                                name="amount"
                                value={state.parts[ID] || 0}
                                onChange={(e) => handleChange(e, ID)}
                                error={state.errors[ID]}
                                helperText={`Max: ${state.max[ID]} / ${state.total[ID]}`}
                                size="small"
                            />
                        </ListItemSecondaryAction>
                        <hr />
                    </ListItem>
                );
            })}
        </LinkSpending>
    );
};

export default LinkPurchasePopUp;
